class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      const secondDrawerScreenActive = this.querySelector("free-items-drawer").classList.contains("active");
      const thirdDrawerScreenActive = this.querySelector(".free-items-category-drawer.active");

      console.log(secondDrawerScreenActive,this.querySelector("free-items-drawer"));

      if (evt.code === 'Escape') {
        if (thirdDrawerScreenActive) {
          this.closest("cart-drawer").querySelector('.free-items-category-drawer.active').querySelector('.free-items-drawer__close').click();
        } else if (secondDrawerScreenActive) {
          this.closest("cart-drawer").querySelector('.free-items-drawer__close').click();
        } else {
          this.close();
        }
      }
    });

    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    if (window.location.href.includes("flyout=open")) {
      this.open();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener('transitionend', () => {
      this.intentionallyTrapFocus();
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    /* Close other drawers if they are opened */
    const freeItemsDrawer = this.querySelector("free-items-drawer");
    freeItemsDrawer.classList.contains("active") && freeItemsDrawer.close();

    const activeFreeItemsCategoryDrawer = this.querySelector(".free-items-category-drawer.active") || null;
    activeFreeItemsCategoryDrawer && activeFreeItemsCategoryDrawer.classList.remove("active");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.intentionallyTrapFocus();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  intentionallyTrapFocus(element) {
    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.querySelector('.drawer__inner');
    const focusElement = this.querySelector('.drawer__close');
    trapFocus(containerToTrapFocusOn, element || focusElement);
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  static observedAttributes = ["data-total", "data-free-item-in-cart"];

  constructor() {
    super();
    this.amount_settings = {};
    this.step_settings = {};
    this.thresholds = {};
    this.INDICATOR_THRESHOLD = 0;
    this.FREE_ITEM_IN_THE_CART = !!this.querySelector(".CartDrawer__FreeItem-Container");
    
    this.cartDrawer = this.closest("cart-drawer");

    this.messages = {
      freeShipping: {
        top: "Almost there!",
        message: (amount) =>
          Shopify.currency.active === "USD"
            ? `$${amount.toFixed(2)} away from FREE shipping!`
            : `${amount.toFixed(2)} ${Shopify.currency.active} away from FREE shipping!`,
      },
      freeProduct1: {
        top: "Hair-YAY! You Qualify for FREE Shipping!",
        message: (amount) =>
          Shopify.currency.active === "USD"
            ? `$${amount.toFixed(2)} away from a FREE item!`
            : `${amount.toFixed(2)} ${Shopify.currency.active} away from a FREE item!`,
      },
      freeProduct2: {
        top: "Hair-YAY! You’ve received FREE Shipping, now choose your FREE item!",
        message: (amount) =>
          Shopify.currency.active === "USD"
            ? `Spend $${amount.toFixed(2)} more to swap your FREE item with a FREE Hair Clip!`
            : `Spend ${amount.toFixed(2)} ${Shopify.currency.active} more to swap your FREE item with a FREE Hair Clip!`,
      },
    };

    this.loadThresholds();
  }

  loadThresholds() {
    const rate = Shopify.currency.rate || 1;
    const shop = window.shop;
    
    this.thresholds = {
      freeShipping: (shop.freeShippingThreshold * rate || 0).toFixed(2),
      freeProduct1: (shop.freeProductsThreshold1 * rate || 0).toFixed(2),
      freeProduct2: (shop.freeProductsThreshold2 * rate || 0).toFixed(2),
    };

    window.shop = {
      ...window.shop,
      FREE_SHIPPING_THRESHOLD: this.thresholds.freeShipping,
      FREE_PRODUCT_THRESHOLD_1: this.thresholds.freeProduct1,
      FREE_PRODUCT_THRESHOLD_2: this.thresholds.freeProduct2,
    };
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === "data-total") {
      this.cartTotal = parseFloat(newValue) || 0;
      if (this.cartTotal > 0) this.calculateAmounts();
    }
    if (name === "data-free-item-in-cart" && newValue === "added") {
      this.FREE_ITEM_IN_THE_CART = true;
      this.calculateAmounts();
    }
  }

  calculateAmounts() {
    const { cartTotal } = this;
    const { freeShipping, freeProduct1, freeProduct2 } = this.thresholds;
    
    this.INDICATOR_THRESHOLD = freeShipping;

    if (cartTotal > freeShipping && cartTotal < freeProduct1) {
      this.INDICATOR_THRESHOLD = freeProduct1;
    } else if (cartTotal > freeProduct1 && cartTotal < freeProduct2) {
      this.INDICATOR_THRESHOLD = freeProduct2
    }
    
    this.step_settings = {
      STEP_BEFORE_FREE_SHIPPING: cartTotal < freeShipping,
      STEP_BEFORE_FREE_PRODUCT_1: cartTotal >= freeShipping && cartTotal < freeProduct1,
      STEP_BEFORE_FREE_PRODUCT_2: cartTotal >= freeProduct1 && cartTotal < freeProduct2,
    };

    this.amount_settings = {
      AMOUNT_TO_REACH_FREE_SHIPPING: Math.max(freeShipping - cartTotal, 0),
      AMOUNT_TO_REACH_FREE_PRODUCT_1: Math.max(freeProduct1 - cartTotal, 0),
      AMOUNT_TO_REACH_FREE_PRODUCT_2: Math.max(freeProduct2 - cartTotal, 0),
    };

    this.renderMessages();
  }

  renderMessages() {
    const { 
      AMOUNT_TO_REACH_FREE_SHIPPING,
      AMOUNT_TO_REACH_FREE_PRODUCT_1,
      AMOUNT_TO_REACH_FREE_PRODUCT_2 
    } = this.amount_settings;

    const { 
      STEP_BEFORE_FREE_SHIPPING,
      STEP_BEFORE_FREE_PRODUCT_1,
      STEP_BEFORE_FREE_PRODUCT_2 
    } = this.step_settings;

    const { 
      cartTotal,
      FREE_ITEM_IN_THE_CART,
      thresholds,
      messages 
    } = this;

    const freeShippingIndicatorElement = this.querySelector("[data-free-shipping-indicator]").content.firstElementChild.cloneNode(true);
    freeShippingIndicatorElement.setAttribute("threshold", this.INDICATOR_THRESHOLD);
    freeShippingIndicatorElement.setAttribute("cart-total", this.cartTotal);

    const freeProduct2Element = this.cartDrawer.querySelector("[data-category='threshold-2']");
    freeProduct2Element.classList.add("hidden");
    
    const container = this.querySelector(".cart-drawer-interactive-section");
    container.innerHTML = "";

    const topMessage = document.createElement("div");
    topMessage.classList.add("topMessage");
    const bottomMessage = document.createElement("p");
    bottomMessage.classList.add("bottomMessage");
    
    let freeItemsButtonText = "";
    let freeItemButtonElement = null;

    if (STEP_BEFORE_FREE_SHIPPING) {
      topMessage.textContent = messages.freeShipping.top;
      bottomMessage.textContent = messages.freeShipping.message(AMOUNT_TO_REACH_FREE_SHIPPING);
    } else if (STEP_BEFORE_FREE_PRODUCT_1) {
      if (!FREE_ITEM_IN_THE_CART) topMessage.textContent = messages.freeProduct1.top;
      bottomMessage.textContent = messages.freeProduct1.message(AMOUNT_TO_REACH_FREE_PRODUCT_1);
    } else if (STEP_BEFORE_FREE_PRODUCT_2) {
      if (!FREE_ITEM_IN_THE_CART) topMessage.textContent = messages.freeProduct2.top;
      bottomMessage.textContent = messages.freeProduct2.message(AMOUNT_TO_REACH_FREE_PRODUCT_2);
      freeItemsButtonText = FREE_ITEM_IN_THE_CART ? "CHANGE FREE ITEM" : "SELECT FREE ITEM";
    } else if (cartTotal >= thresholds.freeProduct2) {
      freeProduct2Element.classList.remove("hidden");
      if (!FREE_ITEM_IN_THE_CART) topMessage.textContent = messages.freeProduct2.top;
      freeItemsButtonText = FREE_ITEM_IN_THE_CART ? "CHANGE FREE ITEM" : "SELECT FREE ITEM";
    }

    container.appendChild(topMessage);
    
    if (freeItemsButtonText && cartTotal > thresholds.freeProduct1) {
      const freeItemToggleButton = document.createElement("button");
      freeItemToggleButton.classList.add("button", "button-open-free-item-modal");
      freeItemToggleButton.setAttribute("aria-haspopup", "dialog");
      freeItemToggleButton.textContent = freeItemsButtonText;

      freeItemToggleButton.addEventListener("click", () => {
        this.closest("cart-drawer").querySelector("free-items-drawer").open();
        this.closest("cart-drawer").querySelector("free-items-drawer").intentionallyTrapFocus();
      });

      container.appendChild(freeItemToggleButton);
    }
    
    container.appendChild(bottomMessage);

    if (cartTotal < thresholds.freeProduct2) {
      container.appendChild(freeShippingIndicatorElement);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);